import { useMemo } from 'react';
import { SidebarSearchWorkspaceItemContainer } from './SidebarSearchWorkspaceItemContainer';
import { Workspace } from '@workspace/domain/workspace';
import { useAtomValue } from 'jotai';
import { filteredAllSearchRecordsAtom } from './searchResultState';
import { RootFolderTree } from '@workspace/view-model-folder/domain/FolderTree';

export const SearchResult: React.FC = () => {
  const records = useAtomValue(filteredAllSearchRecordsAtom);

  const sortedWorkspaces = useMemo(() => {
    if (!records) return [];

    return Object.values(records.workspaces).sort(Workspace.compare);
  }, [records]);

  if (sortedWorkspaces.length === 0) return null;

  return (
    <div className="mb-4">
      <div className="text-xs font-bold">ビューモデル</div>
      <div className="ml-4">
        {sortedWorkspaces.map((workspace) => {
          const rootFolderTree = records.folderTrees[workspace.id] || RootFolderTree.buildEmpty();
          return (
            <SidebarSearchWorkspaceItemContainer
              key={workspace.id}
              workspace={workspace}
              rootFolderTree={rootFolderTree}
            />
          );
        })}
      </div>
    </div>
  );
};
